<template>
 

<v-main>
   <v-app center style='background-image: linear-gradient(to bottom right, #FAFAFA ,  #BBDEFB); opaminhali: 90%;' >

     <v-container>
      <v-app-bar id="app_bar"
      app
      color="#056ba6"
      dark
      style="width:100%"
    >
      <v-app-bar-nav-icon v-if="isMobile()"  @click.stop="drawer = !drawer"></v-app-bar-nav-icon>


       <v-img v-if="isMobile() == false"
        src="./images/logos/mapi.png"
        :max-height="60" 
        :max-width="60"
        contain
        style="margin-right: 5px; margin-left: 5px;"
      ></v-img>

       <v-img v-if="isMobile() == true"
        src="./images/logos/mapi.png"
        max-height="30" 
        max-width="30"
        contain
        style="margin-right: 5px; margin-left: 5px;"
      ></v-img>
      <v-toolbar-title>אטלס</v-toolbar-title>

      <v-divider v-if="isMobile() == false"
  vertical style="border-color:white !important; margin-right: 18px"
></v-divider>


	<div v-if="isMobile() == false" class="text-right" style="text-align:right">
		
		<v-tooltip bottom>
			<template v-slot:activator="{ on, attrs }">
		<v-btn
			id="save"
			icon
			color="white"
			@click="exportMap"
			v-bind="attrs"
			v-on="on">
			<v-icon light>mdi-content-save</v-icon>
		</v-btn>
	</template>
	<span>שמור מפה כקובץ</span>
	</v-tooltip>



	<v-tooltip bottom>
			<template v-slot:activator="{ on, attrs }">
		<v-btn
    id="print"
		icon
		color="white"
		@click="print"
		v-bind="attrs"
		v-on="on">
		<v-icon light>mdi-printer</v-icon>
		</v-btn>
	</template>
	<span>הדפס מפה</span>
	</v-tooltip>
  
  <v-tooltip bottom>
			<template v-slot:activator="{ on, attrs }">
		<v-btn
    id="Measure"
		icon
		color="white"
		@click="Measure"
		v-bind="attrs"
		v-on="on">
		<v-icon light>mdi-ruler-square</v-icon>
		</v-btn>
	</template>
	<span>מדידות על המפה</span>
	</v-tooltip>





	</div>


  <v-divider v-if="isMobile() == false"
  vertical style="border-color:white !important; margin-right: 18px"
></v-divider>

  





	<v-spacer></v-spacer>
  <v-row v-if="isMobile() == false">
    <v-spacer></v-spacer>



    <v-img
        src="./images/logos/logo_misrad_hinuh_3.png"
        :max-height="63" 
        :max-width="70"
        contain
        style="margin-right: 5px; margin-left: 5px;"
      ></v-img>

      <v-divider
  vertical style="border-color:white !important;"
></v-divider>

      <v-img
        src="./images/logos/lamas2.png"
        max-height="63"
        max-width="63"
        contain
        style="margin-right: 10px; margin-left: 10px;"
      ></v-img>

      <v-divider
        vertical style="border-color:white !important;"
      ></v-divider>

     <v-img
        src="./images/logos/huji3.png"
        max-height="63"
        max-width="200"
        contain
        style="margin-right: 5px; margin-left: 5px;"
      ></v-img>
</v-row>



<v-row v-if="isMobile() == true">

  

  <v-spacer></v-spacer>

    <v-img
        src="./images/logos/logo_misrad_hinuh_3.png"
        max-height="37" 
        max-width="37"
        contain
        style="margin-right: 3px; margin-left: 3px;"
      ></v-img>

      <v-divider
  vertical style="border-color:white !important;"
></v-divider>

      <v-img
        src="./images/logos/lamas2.png"
        max-height="37"
        max-width="37"
        contain
        style="margin-right: 5px; margin-left: 5px;"
      ></v-img>

      <v-divider
        vertical style="border-color:white !important;"
      ></v-divider>

     <v-img
        src="./images/logos/huji3.png"
        max-height="40"
        max-width="120"
        contain
        style="margin-right: 3px; margin-left: 3px;"
      ></v-img>
</v-row>

    
    </v-app-bar>

     <v-navigation-drawer disable-resize-watcher floating v-if="isMobile()"
      v-model="drawer"
      absolute
      right
      temporary
      v-bind:style= "[isMobile() == false ? { 'overflow': 'scroll', 'max-height': '90%','position': 'fixed',  'margin-top':'64px', 'width': 'fit-content'} : {'overflow': 'scroll', 'max-height': '90%','position': 'fixed', 'max-width': '300px', 'position': 'fixed',  'margin-top':'56px', 'width': 'fit-content'} ]"
    >  
    <div style="float:left; margin-left:5px; font-weight: bold; cursor: pointer;" @click="drawer=false">x</div>
    
    <ExpansionPanels/>
    

    </v-navigation-drawer>



    

       <v-row>

        <v-col v-if="!isMobile()" cols="12"  xs="12" sm="12" :md="layersCol" >
          <v-system-bar dark color="#455A64">
          <span>שכבות</span>
          </v-system-bar>
          <ExpansionPanels/>
        </v-col>
              
        <v-col v-if="anyLayers"  class="slide-in-right"
            cols="12"  xs="12" sm="12" md="3"
          >

             <v-system-bar dark color="#455A64">

              <span>מקרא</span>
              
              <v-spacer></v-spacer>
              <v-badge
                        color="green"
                        :content="$store.state.selectedlayers.length"
                        v-if="$store.state.selectedlayers.length > 0"
                      >
               </v-badge>
              
              <v-icon v-if="$store.state.selectedlayers.length > 0" @click="$store.state.selectedlayers=[]">mdi-window-close</v-icon>
              <v-icon v-else @click="getSelectedLayers()">mdi-plus</v-icon>

              
              </v-system-bar>
              
    
        <div id="legend"   style= "overflow: scroll; max-height: 568px;" v-if="$store.state.selectedlayers.length > 0">
 

           <v-card tile v-for="(layer,i) in $store.state.selectedlayers" :key="i">
              <v-list dense>
                <v-subheader>{{layer.text}}</v-subheader>
                <v-list-item-group>
                  <v-list-item
                    v-for="(item, ii) in layer.items" :key="ii"
                    @click="clickLegend(layer,item)"
                  >
                    <v-list-item-icon>
                      <v-img max-height="40" max-width="40" :src="item.icon"></v-img>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title v-text="item.text"></v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
               <v-divider></v-divider>
            </v-card>
           
        </div>
         </v-col>


          <v-col cols="12"  xs="12" sm="12" :md="legendCol">
            <v-system-bar dark color="#455A64">
              <span> 
                <v-icon style="margin-left: 15px" small>
                  mdi-navigation
                </v-icon>
                {{scale}}
              </span>

              <v-spacer></v-spacer>
              
  <v-text-field  id="myInput1" v-if="isMobile() == false" v-model="geocode_text" style="max-width: 250px; margin-top: 25px; text-align: right; border-color:white !important; margin-right: 18px"
      placeholder="התמקדות לכתובת או ישוב"
	></v-text-field>
	<v-btn v-if="isMobile() == false"
	icon
	color="white"
	@click="geocode"
  >
	<v-icon>mdi-magnify</v-icon>
  </v-btn>
	
            </v-system-bar>

            <div style="max-height: 568px;">
              <v-card id="map_div">
                <MapDiv/>
              </v-card>
            </div>
          </v-col>

          <v-col 
            cols="12" xs="12" sm="12"  md="12">

          <v-card id="DataCard">
            <RegionDataDiv v-if="layer_index==0" ></RegionDataDiv>
            <ArabDataDiv v-if="layer_index==1"></ArabDataDiv>
             <NaturalAreaDiv v-if="layer_index==2"></NaturalAreaDiv>
            

              </v-card>


               </v-col>
        
        </v-row>
        </v-container>
     </v-app>

      <v-snackbar
      v-model="$store.state.clickMapMessage"
      centered
      color="green"
      dark
      elevation="24"
      :timeout="2000"
    >
      ניתן לבחור מתוך המפה
      </v-snackbar>


      <v-fab-transition>
        <v-btn style="position:fixed;
              left:25px;
              bottom:50px;"
          color='green'
          fab
          large
          dark
          bottom
          left
          @click="scrollUp"
          v-show="showArrow"
        >
          <v-icon>mdi-chevron-up</v-icon>
        </v-btn>
      </v-fab-transition>


      <v-fab-transition>
        <v-chip style="position:fixed;
              left:25px;
              top:70px;"
          color='red'
          class="ma-2"
          fab
          dark
          bottom
          left
          @click="clearSelection"
          v-show="closeArrow"
          v-if="anyLayers"
        >
          <v-icon>mdi-close</v-icon>
          ביטול בחירה
          </v-chip>
      </v-fab-transition>



      <v-row justify="center">
    <v-dialog
      v-model="$store.state.showLayerInfo"
      persistent
      max-width="350"
    >
      <v-card>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-icon  @click="$store.state.showLayerInfo = false">mdi-close</v-icon>
     
        </v-card-actions>
        <v-card-title class="text-h5">
          {{LayerNameInfo}}
          
        </v-card-title>
        <v-card-text>
          מקור השכבה...
          רקע לשכבה...

        </v-card-text>

      </v-card>
    </v-dialog>
  </v-row>





   

    </v-main>
 
</template>


    <script src="https://code.jquery.com/jquery-1.12.1.min.js"></script>
    <script src="https://www.govmap.gov.il/govmap/api/govmap.api.js"></script>
    <script src="https://cdnjs.cloudflare.com/ajax/libs/Chart.js/2.4.0/Chart.min.js"></script>

    <!-- Hotjar Tracking Code for https://www.govmap.gov.il -->
<script>
    (function(h,o,t,j,a,r){
        h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
        h._hjSettings={hjid:2785647,hjsv:6};
        a=o.getElementsByTagName('head')[0];
        r=o.createElement('script');r.async=1;
        r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
        a.appendChild(r);
    })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
</script>

        <script>
        var exports = {};
        var globalAppVersion = (new Date()).getTime();
        document.write("<script src='https://es.govmap.gov.il/TldSearch/Scripts/ac.js?v=" + globalAppVersion + " '><\/script>")
    </script>

<script>







//var my_token= '5a4b8472-b95b-4687-8179-0ccb621c7990';
//var my_token ='aafedfe5-8dfa-4fd5-9af9-8b95759447bd'; // my github
var my_token = '76b35124-4d1f-44b5-a612-3463951f89f9'//my atlas-il on firebase


import MapDiv from './components/MapDiv';
import RegionDataDiv from './components/RegionDataDiv';
import ArabDataDiv from './components/ArabDataDiv';
import NaturalAreaDiv from './components/NaturalAreaDiv';
import ExpansionPanels from './components/ExpansionPanels';




    function PointToPolygon(x, y, r)
		{			
			var x1 = x - r;
			var y1 = y;
			var x2 = x - (((r / 2)) / (2)) - ((r / 2));
			var y2 = y + (((r / 2)) / (2)) + ((r / 2));
			var x3 = x;
			var y3 = y + r;
			var x4 = x + (((r / 2)) / (2)) + ((r / 2));
			var y4 = y + (((r / 2)) / (2)) + ((r / 2));
			var x5 = x + r;
			var y5 = y;
			var x6 = x + (((r / 2)) / (2)) + ((r / 2));
			var y6 = y - (((r / 2)) / (2)) - ((r / 2));
			var x7 = x;
			var y7 = y - r;
			var x8 = x - (((r / 2)) / (2)) - ((r / 2));
			var y8 = y - (((r / 2)) / (2)) - ((r / 2));
			var wkt = "POLYGON(("+x1+" "+y1+", "+x2+" "+y2+", "+x3+" "+y3+", "+x4+" "+y4+", "+x5+" "+y5+", "+x6+" "+y6+", "+x7+" "+y7+", "+x8+" "+y8+", "+x1+" "+y1+"))";
			return wkt;
		}

var appVue;
var testMode = false;
$(document).ready(function (){

	(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
Object.defineProperty(exports, "__esModule", { value: true });

var baseUrl = 'https://es.govmap.gov.il/TldSearch';

var inputElement1 = document.getElementById("myInput1");

myInput1.style.height = "40px";

var options1 = {
    url: baseUrl,
    subjectId: 0,
    gid: '',
    debounce: 200,
    minLength: 1,
    placeholder: "חיפוש ישוב או כתובת",
    clearOnClick: true,
    onInput: function onInput(res) {
        options1.subjectId = 16399;
        if (!testMode) {
            options1.gid = "nadlan";
        }
    },
    onSelect: function onSelect(res) {
        //console.log(res.query);
        appVue.geocode_text = res.query;
    }
};



var testMode = false;
//console.log(autocomplete);
var ac1 = autocomplete(inputElement1, options1);
},{}]},{},[1])
});


export default {
  name: 'App',

  components: {
    MapDiv, RegionDataDiv, ArabDataDiv, NaturalAreaDiv, ExpansionPanels
  },

  data: () => ({
        scale: ' קנה מידה 3,000,000 : 1',
        geocode_text: "",
        isActive: false,
        isCityActive: false,
        isMinhaliActive: false,
        showArrow:false,
        closeArrow:false,
        clickMapMessage: false,
        drawer: false,
        group: null,
        region: "",
        region_eng: "",
        selected: [],
        selected_rails: [],
        selectedItem: 1,
        layer: null,
        selectedlayers: [],
        transport_selected: [],
        selected_city: [],
        env_selected:[],


         items: [],
      model: 1,
      //layer_index: -1,
    //
  }),

  methods:{

     getSelectedLayers(){

        this.$store.state.selectedlayers = [];

        var newarray = [];
        
        for (var a = 0; a < this.$store.state.groups.length; a++)
        {
            for (var b = 0; b < this.$store.state.groups[a].sub_groups.length; b++)
            {
                    ////console.log(this.$store.state.groups[a].sub_groups[b].selected);
                    this.$store.state.groups[a].sub_groups[b]
                    for (var i = 0; i < this.$store.state.groups[a].sub_groups[b].selected.length; i++)
                    {
                        ////console.log(this.$store.state.groups[a].sub_groups[b].selected[i]);
                        newarray.push(this.$store.state.groups[a].sub_groups[b].selected[i])
                    }
                
            }
        }

        for (var a = 0; a < this.$store.state.groups.length; a++)
        {
            for (var b = 0; b < this.$store.state.groups[a].sub_groups.length; b++)
            {
                  ////console.log(this.$store.state.groups[a].sub_groups[b].selected);
                  var layers = this.$store.state.groups[a].sub_groups[b].sub_group_layers;
                  //console.log(layers);
                  //console.log(newarray);
                  var res = layers.filter(item => newarray.includes(item.layer_name));
                  //console.log("res");
                  //console.log(res);
                  for (var i = 0; i < res.length; i++ )
                  {
                      //this.$store.state.selectedlayers.push(res[i]);
                                  
                        var symbols = this.createRenderer(res[i]);
                        ////console.log(symbols);
                        var obj = {
                          layer_name: res[i].layer_name,
                          text: res[i].text,
                          items: symbols
                        }
                        
                        this.$store.state.selectedlayers.push(obj);
                  }
            }
        }
        console.log(this.$store.state.selectedlayers);
        this.$store.state.turnOnLayers = newarray;
        this.$store.state.turnOffLayers = this.getUnselectedLayers()


        if (this.$store.state.selectedMinhaliLayer){
            var symbols = this.createRenderer(this.$store.state.selectedMinhaliLayer);
            ////console.log(symbols);
            var obj = {
              layer_name: this.$store.state.selectedMinhaliLayer.layer_name,
              text: this.$store.state.selectedMinhaliLayer.text,
              items: symbols,
              symbol_field: this.$store.state.selectedMinhaliLayer.symbol_field

            }

            this.$store.state.selectedlayers.push(obj);
        }
        if (this.$store.state.selectedLayer){
            var symbols = this.createRenderer(this.$store.state.selectedLayer);
            ////console.log(symbols);
            var obj = {
              layer_name: this.$store.state.selectedLayer.layer_name,
              text: this.$store.state.selectedLayer.text,
              items: symbols,
            }
            this.$store.state.selectedlayers.push(obj);
        }

        return newarray
    },

       getUnselectedLayers () { 
        var newarray = [];
        for (var a = 0; a < this.$store.state.groups.length; a++)
        {
            for (var b = 0; b < this.$store.state.groups[a].sub_groups.length; b++)
            {
              for (var i = 0; i < this.$store.state.groups[a].sub_groups[b].sub_group_layers.length; i++)
              {
                //console.log(this.$store.state.groups[a].sub_groups[b].sub_group_layers.length);
                if (!this.$store.state.groups[a].sub_groups[b].selected.includes(this.$store.state.groups[a].sub_groups[b].sub_group_layers[i].layer_name)){
                    newarray.push(this.$store.state.groups[a].sub_groups[b].sub_group_layers[i].layer_name);
                }   
              }        
            }
         }
      //console.log(newarray);
      return newarray
    },


    layerInfo(item){

      this.$store.state.LayerNameInfo = item.text;
      this.$store.state.showLayerInfo = true;   

    },
    clickLegend(layer,item){
      console.log(item.text);
      console.log(layer.layer_name);
      console.log(layer.symbol_field);
      var params = {
                      'layerName': layer.layer_name,
                      'fieldName': layer.symbol_field,
                      'fieldValues': [item.text],
                      'highlight': true,
                      'showBubble':false,
                      'outLineColor':[127, 246, 223, 1],
                      'outlineWidth': 1, 
                      'fillColor': [255, 255, 255, 0.5]
                  };
      //govmap.searchInLayer(params);

      govmap.searchInLayer({ 'layerName': layer.layer_name, 'fieldName': layer.symbol_field,
                  'fieldValues': [item.text],
                  'highlight': true,
                  'showBubble':false,
                  'outLineColor':[127, 246, 223, 1],
                  'outlineWidth': 1, 
                  'fillColor': [255, 255, 255, 0.5]});
      

    },
    geocode () {
			
			//console.log(this.geocode_text);


			govmap.geocode({keyword: this.geocode_text},govmap.geocodeType.FullResult)
					.then(function(response){
						//console.log("then:");
						//console.log(response);
						govmap.zoomToXY({ x: response.data[0].X, y: response.data[0].Y, level: 10, marker: true });
			});

		},
    Measure()
    {
      govmap.showMeasure();  
    },
    exportMap(){
			govmap.showExportMap();
		},
		print(){
			govmap.showPrint();
		},
    click(item){
      console.log(item);
      
    },
      createSelectedLayers(){
      this.$store.state.selectedlayers= [];
      for (var i = 0; i < this.$store.state.temprature_layers.length; i++)
      {
        if (this.selected.includes(this.$store.state.temprature_layers[i].layer_name)){
          var symbols = this.createRenderer(this.$store.state.temprature_layers[i]);
          //console.log(symbols);
          var obj = {
            layer_name: this.$store.state.temprature_layers[i].layer_name,
            text: this.$store.state.temprature_layers[i].text,
            items:  symbols,
            symbol_field: this.$store.state.temprature_layers[i].symbol_field

          }

          this.$store.state.selectedlayers.push(obj);
        }
      }
      for (var i = 0; i < this.$store.state.geologics_layers.length; i++)
      {
        if (this.selected.includes(this.$store.state.geologics_layers[i].layer_name)){
          var symbols = this.createRenderer(this.$store.state.geologics_layers[i]);
          //console.log(symbols);
          var obj = {
            layer_name: this.$store.state.geologics_layers[i].layer_name,
            text: this.$store.state.geologics_layers[i].text,
            items: symbols,
            symbol_field: this.$store.state.geologics_layers[i].symbol_field

          }
          this.$store.state.selectedlayers.push(obj)
        }
      }
       for (var i = 0; i < this.$store.state.environment_layers.length; i++)
       {
        if (this.env_selected.includes(this.$store.state.environment_layers[i].layer_name)){
          var symbols = this.createRenderer(this.$store.state.environment_layers[i]);
          //console.log(symbols);
          var obj = {
            layer_name: this.$store.state.environment_layers[i].layer_name,
            text: this.$store.state.environment_layers[i].text,
            items: symbols,
            symbol_field: this.$store.state.environment_layers[i].symbol_field

          }
          this.$store.state.selectedlayers.push(obj)
        }
      }
      for (var i = 0; i < this.$store.state.transportation_layers.length; i++)
      {
        if (this.transport_selected.includes(this.$store.state.transportation_layers[i].layer_name)){
          var symbols = this.createRenderer(this.$store.state.transportation_layers[i]);
          //console.log(symbols);
            var obj = {
            layer_name: this.$store.state.transportation_layers[i].layer_name,
            text: this.$store.state.transportation_layers[i].text,
            items: symbols,
            symbol_field: this.$store.state.transportation_layers[i].symbol_field

          }

          this.$store.state.selectedlayers.push(obj);
        }
      }
      for (var i = 0; i < this.$store.state.rails_layers.length; i++)
      {
        if (this.selected_rails.includes(this.$store.state.rails_layers[i].layer_name)){
           var symbols = this.createRenderer(this.$store.state.rails_layers[i]);
           //console.log(symbols);
          var obj = {
            layer_name: this.$store.state.rails_layers[i].layer_name,
            text: this.$store.state.rails_layers[i].text,
            items: symbols,
            symbol_field: this.$store.state.rails_layers.symbol_field

          }

          this.$store.state.selectedlayers.push(obj);
        }
      }
      for (var i = 0; i < this.$store.state.cities.length; i++)
      {
        if (this.selected_city.includes(this.$store.state.cities[i].layer_name)){
          console.log("yes");
           var symbols = this.createRenderer(this.$store.state.cities[i]);
           //console.log(symbols);
          var obj = {
            layer_name: this.$store.state.cities[i].layer_name,
            text: this.$store.state.cities[i].text,
            items: symbols,
            symbol_field: this.$store.state.cities.symbol_field

          }

          this.$store.state.selectedlayers.push(obj);
        }
      }
      if (this.selectedMinhaliLayer){
          console.log(this.selectedMinhaliLayer);
           var symbols = this.createRenderer(this.selectedMinhaliLayer);
           //console.log(symbols);
          var obj = {
            layer_name: this.selectedMinhaliLayer.layer_name,
            text: this.selectedMinhaliLayer.text,
            items: symbols,
            symbol_field: this.selectedMinhaliLayer.symbol_field

          }

          this.$store.state.selectedlayers.push(obj);
      }
      if (this.selectedLayer){
           var symbols = this.createRenderer(this.selectedLayer);
           //console.log(symbols);
          var obj = {
            layer_name: this.selectedLayer.layer_name,
            text: this.selectedLayer.text,
            items: symbols,
            symbol_field: this.selectedLayer.symbol_field
          }
          this.$store.state.selectedlayers.push(obj);
      }


      //console.log(this.$store.state.selectedlayers);


    },

    
    createRenderer(layer)
    {
        //var appVue = this;
        var layerForRenderer = [];
        var lname = layer.layer_name;
        //this.layer = layer.text;
        layerForRenderer.push(lname);

        var items = [];

        var layers = { LayerNames: layerForRenderer };

        govmap.getLayerRenderer(layers)
            .then(function (e) {
                console.log(e);
                for (var object in e.data.Renderers) {
                    for (var obj in e.data.Renderers[object].RendererList) {
                        if (obj == "") {

                          //console.log(e.data.Renderers[object].LayerCaption)
                          items.push({text: "", icon: e.data.Renderers[object].RendererList[obj] });
                        }
                        else
                        {
                          //console.log(obj)
                          //td.appendChild(document.createTextNode(obj));
                          items.push({text:obj, icon: e.data.Renderers[object].RendererList[obj] });
                          //document.getElementById('rndrHeader').innerHTML = lyrRendererDesc[lname];
                        }
      
                    }

                    if (layer.layer_name== "HEAT"){
                        items.push(items.shift())
                      //items = items.sort((a, b) => (a.text > b.text) ? 1 : -1)
                    }
                    if (layer.layer_name== "earthquakes"){
                       items.unshift(items.pop())
                    }

                    ////console.log(items);
                    
                    

                }
                

            });
 
            return items;
            
            

    },

    turn(){
      ////console.log(this.selected)
    },

    clearSelection(){
      //////console.log(this.$store.state.layer_index);
      govmap.clearSelection();
      //this.$store.state.layer_index = -1;
      this.$store.state.selected_data_reg= [];
      this.$store.state.selected_data_arab= [];
      //this.$store.state.selectedLayer= null;
      this.$store.state.img = "";
      this.closeArrow = false;

            this.$store.state.img = "https://raw.githubusercontent.com/yovavsanders/govmap/master/images/"+this.selectedLayer.layer_name+".jpg";
      //////console.log(this.$store.state.img)
      //////console.log(this.$store.state.img);
      govmap.setVisibleLayers([this.selectedLayer.layer_name], this.unselectedLayers)
      if(this.isMobile()){
        this.drawer = false;
      }

      //this.scrollUp();


    },

    scrollUp(){
       $('html, body').animate({ scrollTop: 0 }, 'fast');
       this.showArrow=false;
    },

     isMobile() {
      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },

    switchCityLayer(i){
      console.log(i);
        this.$store.state.layer_index = -1;
        console.log(this.selected_city);
        govmap.setVisibleLayers(this.selected_city, this.getUnselectedCityLayers());
        govmap.zoomToXY({ x: 179300, y: 661800, level: 4, marker: false });
         if(!this.isMobile()){
          this.getSelectedLayers;
         }
    },
      switchMinhaliLayer(i){
        console.log(this.$store.state.minhali_index);
      if (i == this.$store.state.minhali_index)
      {
        if (!this.isMinhaliActive) {
          this.isMinhaliActive = true;
          this.$store.state.minhali_index = i;
            this.$store.state.selectedMinhaliLayer = this.$store.state.minhali[this.$store.state.minhali_index];
            govmap.setVisibleLayers([this.$store.state.selectedMinhaliLayer.layer_name], this.unselectedMinhaliLayers);
            if(this.isMobile()){
              this.drawer = false;
            }
            else{
              this.getSelectedLayers;
            }

        } else {
          this.isMinhaliActive = false;
          this.$store.state.minhali_index = -1;
          this.$store.state.selectedminhaliLayer = null;
          //this.selectedminhaliLayer = null;
          govmap.setVisibleLayers([], this.allMinhaliLayers);

        }
      }
      else{
        this.isminhaliActive = false;
          this.$store.state.minhali_index = i;
          console.log("minhali_index" + i);
            this.$store.state.selectedMinhaliLayer = this.$store.state.minhali[this.$store.state.minhali_index];
            console.log(this.$store.state.selectedMinhaliLayer);
            govmap.setVisibleLayers([this.$store.state.selectedMinhaliLayer.layer_name], this.unselectedMinhaliLayers);
            if(this.isMobile()){
              this.drawer = false;
            }
            else{
              this.getSelectedLayers;
            }

            this.isMinhaliActive = true
      }

    },
  
    switchLayer(i){
      if (i == this.$store.state.layer_index)
      {
        if (!this.isActive) {
          this.isActive = true;
          this.$store.state.layer_index = i;
          this.$store.state.selectedLayer = this.$store.state.layers[this.$store.state.layer_index];
          this.$store.state.img = "https://raw.githubusercontent.com/yovavsanders/govmap/master/images/"+this.selectedLayer.layer_name+".jpg";
          //////console.log(this.$store.state.img)
          //////console.log(this.$store.state.img);
          govmap.setVisibleLayers([this.selectedLayer.layer_name], this.unselectedLayers)
          this.clickMapMessage = true;
        } else {
          this.isActive = false;
          this.$store.state.layer_index = -1;
          this.$store.state.selectedLayer = null;
          govmap.setVisibleLayers([], this.allLayers)
        }
      }
      else{
          this.isActive = false;
          this.$store.state.layer_index = i;
          this.$store.state.selectedLayer = this.$store.state.layers[this.$store.state.layer_index];
          this.$store.state.img = "https://raw.githubusercontent.com/yovavsanders/govmap/master/images/"+this.selectedLayer.layer_name+".jpg";
          //////console.log(this.$store.state.img)
          //////console.log(this.$store.state.img);
          govmap.setVisibleLayers([this.selectedLayer.layer_name], this.unselectedLayers)
          this.clickMapMessage = true;

          this.isActive = true;

      }
      // if (this.isActive == -1 || this.isActive != i){
      //   this.isActive = i;
      //   this.$store.state.layer_index = i;
      //   this.$store.state.selectedLayer = this.$store.state.layers[this.$store.state.layer_index];
      //   this.$store.state.img = "https://raw.githubusercontent.com/yovavsanders/govmap/master/images/"+this.selectedLayer.layer_name+".jpg";
      //   //////console.log(this.$store.state.img)
      //   //////console.log(this.$store.state.img);
      //   govmap.setVisibleLayers([this.selectedLayer.layer_name], this.unselectedLayers)
      //   this.clickMapMessage = true;
        
      // }
      // else{
      //   this.isActive = -1
      //   this.$store.state.layer_index = -1;
      //   this.$store.state.selectedLayer = null;
      //   govmap.setVisibleLayers([], this.allLayers)
      // }
      
      
      //this.$store.state.layer_index = i;
      //govmap.setVisibleLayers([""], this.allTransLayers)
      //govmap.setVisibleLayers([""], this.allCityLayers)
     
      
      if(this.isMobile()){
        this.drawer = false;
      }
      else{
        this.getSelectedLayers;
      }
      
      
    },
    switchRailsLayer(){

        this.$store.state.layer_index = -1;
        //govmap.setVisibleLayers([""], this.allLayers)
            //////console.log(i)
        //////console.log(this.$store.state.img)
        //////console.log(this.$store.state.img);
        ////console.log("!!!");
        ////console.log(this.selected_rails);
        //govmap.setVisibleLayers([this.$store.state.selectedTransLayer.layer_name], this.unselectedTransLayers)
        govmap.setVisibleLayers(this.selected_rails, this.getUnselectedRailsLayers());
         if(!this.isMobile()){
          this.getSelectedLayers;
         }


    },
    switchTransLayer()
    {
      this.$store.state.layer_index = -1;
      //govmap.setVisibleLayers([""], this.allLayers)
      govmap.setVisibleLayers(this.transport_selected, this.getUnselectedTransLayers());
       if(!this.isMobile()){
      this.getSelectedLayers;
       }
    },

    switchGeologicLayer(){
      this.$store.state.layer_index = -1;
      //govmap.setVisibleLayers([""], this.allLayers)
      govmap.setVisibleLayers(this.selected, this.getUnselectedGeologicsLayers());
       if(!this.isMobile()){
      this.getSelectedLayers;
       }


    },
    switchTempratureLayer(){
      this.$store.state.layer_index = -1;
      //govmap.setVisibleLayers([""], this.allLayers)
      govmap.setVisibleLayers(this.selected, this.getUnselectedTempratureLayers());
       if(!this.isMobile()){
      this.getSelectedLayers;
       }

    },
    switchEnvironmentLayer(){
      this.$store.state.layer_index = -1;
      //govmap.setVisibleLayers([""], this.allLayers)
      //console.log(this.env_selected)
      govmap.setVisibleLayers(this.env_selected, this.getUnselectedEnvironmentLayers());
       if(!this.isMobile()){
      this.getSelectedLayers;
       }


    },


    getUnselectedRailsLayers () { 
      var newarray = [];
      for (var i = 0; i < this.$store.state.rails_layers.length; i++)
      {
        if (!this.selected_rails.includes(this.$store.state.rails_layers[i].layer_name)){
          newarray.push(this.$store.state.rails_layers[i].layer_name)
        }
      }
      //////console.log(newarray);
      return newarray
    },


    getUnselectedTransLayers () { 
      var newarray = [];
      for (var i = 0; i < this.$store.state.transportation_layers.length; i++)
      {
        if (!this.transport_selected.includes(this.$store.state.transportation_layers[i].layer_name)){
          newarray.push(this.$store.state.transportation_layers[i].layer_name)
        }
      }
      //////console.log(newarray);
      return newarray
    },

    getUnselectedCityLayers(){
            var newarray = [];
      for (var i = 0; i < this.$store.state.cities.length; i++)
      {
        if (!this.selected_city.includes(this.$store.state.cities[i].layer_name)){
          newarray.push(this.$store.state.cities[i].layer_name)
        }
      }
      //////console.log(newarray);
      return newarray
      

    },

    getUnselectedEnvironmentLayers () { 
      var newarray = [];
      for (var i = 0; i < this.$store.state.environment_layers.length; i++)
      {
        if (!this.env_selected.includes(this.$store.state.environment_layers[i].layer_name)){
          newarray.push(this.$store.state.environment_layers[i].layer_name)
        }
      }
      //////console.log(newarray);
      return newarray
    },

    getUnselectedGeologicsLayers () { 
      var newarray = [];
      for (var i = 0; i < this.$store.state.geologics_layers.length; i++)
      {
        if (!this.selected.includes(this.$store.state.geologics_layers[i].layer_name)){
          newarray.push(this.$store.state.geologics_layers[i].layer_name)
        }
      }
      //////console.log(newarray);
      return newarray
    },

    getUnselectedTempratureLayers () { 
      var newarray = [];
      for (var i = 0; i < this.$store.state.temprature_layers.length; i++)
      {
        if (!this.selected.includes(this.$store.state.temprature_layers[i].layer_name)){
          newarray.push(this.$store.state.temprature_layers[i].layer_name)
        }
      }
      //////console.log(newarray);
      return newarray
    },

  


    getData(wkt, lyr, fields){
      var thisVue = this;
      thisVue.drawer = false;
        var params = {  
            geometry: wkt, //point: {x: 167127.5939715321,  y: 624580.483296493},  // need wkt polygon...
            layerName: lyr,  
            fields: fields
        }
        govmap.intersectFeatures(params).then(function (response)  
        {  
            //////console.log(response.data[0]);
            var name_eng;
            if (lyr == 'sites_pop_by_region'){
              thisVue.$store.state.selected_data_reg = response.data[0].Values;
              if (lyr == thisVue.selectedLayer.layer_name){
                name_eng = thisVue.$store.state.selected_data_reg[2];
                //thisVue.$store.state.img = "https://raw.githubusercontent.com/yovavsanders/govmap/master/images/sites_pop_by_region/" + name_eng + ".jpg";
              }

            }
            if (lyr == 'sites_arab_pop_by_religion'){
              thisVue.$store.state.selected_data_arab = response.data[0].Values;
              if (lyr == thisVue.selectedLayer.layer_name){
                  name_eng = thisVue.$store.state.selected_data_arab[1];
                  //thisVue.$store.state.img = "https://raw.githubusercontent.com/yovavsanders/govmap/master/images/sites_arab_pop_by_religion/" + name_eng + ".jpg";
              }

            }
            if (lyr == 'sites_pop_by_natural_areas'){
              thisVue.$store.state.selected_data_natural = response.data[0].Values;
              if (lyr == thisVue.selectedLayer.layer_name){
                name_eng = thisVue.$store.state.selected_data_natural[2];
              }
              
            }
            if (lyr == thisVue.selectedLayer.layer_name){
            thisVue.$store.state.img = "https://raw.githubusercontent.com/yovavsanders/govmap/master/images/"+thisVue.selectedLayer.layer_name+"/" + name_eng + ".jpg";
            govmap.searchInLayer({ 'layerName': thisVue.$store.state.layers[thisVue.$store.state.layer_index].layer_name, 'fieldName': 'OBJECTID',
                              'fieldValues': [response.data[0].ObjectId],
                              'highlight': true,
                              'showBubble':false,
                              'outLineColor':[127, 246, 223, 1],
                              'outlineWidth': 1, 
                              'fillColor': [255, 255, 255, 0.5]});
            }
            
            //if (thisVue.isMobile())
            //{
               thisVue.$vuetify.goTo("#DataCard");
               thisVue.showArrow = true;
            //}
        });

    },
  },



  computed:{
     legendCol(){
     if (this.anyLayers){
        
        return 6
       }   
      else{
        return 8
      }
    },

    layersCol(){
     if (this.anyLayers){
        
        return 3
       }   
      else{
        return 4
      }
    },

       anyLayers(){
        if ( this.$store.state.turnOnLayers.length > 0 || this.$store.state.layer_index > -1 || this.$store.state.minhali_index > -1){
          return true;
        }
        else{
          return false;
        }
    },


 


 
    
    showLayerInfo(){
     return this.$store.state.showLayerInfo
    },
    LayerNameInfo(){
      return this.$store.state.LayerNameInfo;
    },
    environment_layers(){
      return this.$store.state.environment_layers;
    },
    
    temprature_layers(){
      return this.$store.state.temprature_layers;
    },
    geologics_layers(){
      return this.$store.state.geologics_layers;
    },
    rails_layers(){
      return this.$store.state.rails_layers;     
    },
    transportation_layers(){
      return this.$store.state.transportation_layers;
    },
     layers(){
       return this.$store.state.layers;
     },
      cities(){
       return this.$store.state.cities;
     },
     minhali(){
        return this.$store.state.minhali;
     },
     minhali_index(){
       return this.$store.state.minhali_index;
     },
     layer_index(){
       return this.$store.state.layer_index;
     },
     selectedLayer () {
      return this.$store.state.selectedLayer;
    },
    selectedTransLayer () {
      return this.$store.state.selectedTransLayer;
    },
    selectedCityLayer(){
      return this.$store.state.selectedCityLayer;
    },
    selectedMinhaliLayer(){
      return this.$store.state.selectedMinhaliLayer;
    },
    unselectedLayers () { 
      var newarray = [];
      for (var i = 0; i < this.$store.state.layers.length; i++)
      {
        if (i != this.$store.state.layer_index){
          newarray.push(this.$store.state.layers[i].layer_name)
        }
      }
      //////console.log(newarray);
      return newarray
    },
    unselectedMinhaliLayers () { 
      var newarray = [];
      for (var i = 0; i < this.$store.state.minhali.length; i++)
      {
        if (i != this.$store.state.minhali_index){
          newarray.push(this.$store.state.minhali[i].layer_name)
        }
      }
      //////console.log(newarray);
      return newarray
    },

    unselectedTransLayers () { 
      var newarray = [];
      ////console.log(this.$store.state.layer_trans_index)
      for (var i = 0; i < this.$store.state.transportation_layers.length; i++)
      {
        if (i != this.$store.state.layer_trans_index){
          newarray.push(this.$store.state.transportation_layers[i].layer_name)
        }
      }
      //////console.log(newarray);
      return newarray
    },
     allLayers () { 
      var newarray = [];
      for (var i = 0; i < this.$store.state.layers.length; i++)
      {
          newarray.push(this.$store.state.layers[i].layer_name)
        
      }
      //////console.log(newarray);
      return newarray
    },
    allTransLayers () { 
      var newarray = [];
      for (var i = 0; i < this.$store.state.transportation_layers.length; i++)
      {
          newarray.push(this.$store.state.transportation_layers[i].layer_name)
        
      }
      //////console.log(newarray);
      return newarray
    },
    allCityLayers () { 
      var newarray = [];
      for (var i = 0; i < this.$store.state.cities.length; i++)
      {
          newarray.push(this.$store.state.cities[i].layer_name)
        
      }
      //////console.log(newarray);
      return newarray
    },
    allMinhaliLayers () { 
      var newarray = [];
      for (var i = 0; i < this.$store.state.minhali.length; i++)
      {
          newarray.push(this.$store.state.minhali[i].layer_name)
        
      }
      //////console.log(newarray);
      return newarray
    },
    selected_data_reg(){
      return this.$store.state.selected_data_reg;
    },
    selected_data_arab(){
      return this.$store.state.selected_data_arab;
    }
  },
  mounted: function () {
    var thisVue = this;
    this.drawer = true;
    if (this.isMobile()){
        document.getElementById("map").style.height = "400px";
        document.getElementById("DataCard").style.height= "100%";
    }
    this.$nextTick(function () {
      // Code that will run only after the
      // entire view has been rendered
      //////console.log("ready!!!");
      appVue = this;
        govmap.createMap('map', 
              {
                  layers: ['geo_formation', 'geo_faults','geo_plutonics','geo_scars','geo_contact','earthquakes',
                   'sites_tkufat_bniya_prod','sites_napot_prod','sites_mahozot_prod',
                   'sites_natural_area_prod','sites_mesilot_barzel_1918_prod', 'sites_mesilot_barzel_2020_prod',
                    'sites_roads_2020_prod', 'sites_roads_1968_2006_prod', 'sites_roads_1948_1967_prod', 
                    'sites_roads_1937_1947_prod', 'sites_roads_1937_prod','sites_mesilot_barzel_1918_prod',
                     'sites_pop_by_region', 'sites_arab_pop_by_religion', 'sites_pop_by_natural_areas',
                      'sites_pop_by_mahoz', 'sites_mahozot_prod', 'sites_napot_prod', 'sites_natural_area_prod',
                      'sites_density_2020_prod','sites_age_group_0_17_prod', 'sites_age_group_0_17_prod','sites_age_group_18_64_prod',
                      'sites_age_group_0_17_prod', 'sites_age_group_18_64_prod', 'sites_age_group_65_90_prod',
                      'sites_education_group_0_4_prod', 'sites_education_group_5_9_prod', 'sites_education_group_10_12_prod',
                      'sites_education_group_13_15_prod', 'sites_education_group_16_prod','sites_river_pollution_prod'],
                  visibleLayers: [],
                  token: my_token,
                  showXY: true,
                  identifyOnClick: true,
                  isEmbeddedToggle: false,
                  background: 0,
                  layersMode: 0,
                  zoomButtons:true,
                  isEmbeddedToggle:false
              });

              //govmap.setVisibleLayers([this.selectedLayer.layer_name], this.unselectedLayers)

              
              setTimeout(function(){
 
                  govmap.onEvent(govmap.events.PAN).progress(function (e)  
                  {  
                    var Xmax = e.extent.xmax;
                    var Xmin = e.extent.xmin;
                    //var Ymax = e.extent.ymax;
                    //var Ymin = e.extent.ymin;
                    var scale = Math.round((Xmax - Xmin)  / (document.getElementById("map").clientWidth * 0.000264583));
                    console.log(scale +"  : 1");
                    appVue.scale = " קנה מידה " + scale.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",").replace(/.$/,"0") + " : 1" ;
                    
                    //x_center = e.extent.xmin + ((e.extent.xmax - e.extent.xmin) / 2);
                    //y_center = e.extent.ymin + ((e.extent.ymax - e.extent.ymin) / 2);

                    
                  });

            }, 3000);

            

    })


  },

     watch: {
    drawer(visible) {
      if (visible) {
        // Here you would put something to happen when dialog opens up
        //console.log("Dialog was opened!")
      } else {
        if (!this.isMobile())
        {
        //console.log("Dialog was closed!")
        this.getSelectedLayers;
        }
      }
              
      
    },
      group () {
        this.drawer = false
      },
    },

  
};



</script>


<style>




/*the container must be positioned relative:*/
.autocomplete {
	position: relative;
	display: inline-block;
	max-height: 44px;
}

.autocomplete input {
	border: 1px solid transparent;
	background-color: grey;
	padding: 1px;
	font-size: 14px;
	height: 30px;
}

.autocomplete-items {
	position: absolute;
	border: 1px solid #d4d4d4;
	/* border-bottom: none; */
	border-top: none;
	z-index: 99;
	/*position the autocomplete items to be the same width as the container:*/
	top: 100%;
	left: 0;
	right: 0;
	color: darkslategray;
	overflow-y: auto;
	max-height: calc(100vh - 200px ) /*todo mobile, calc, scroll on key up/down*/
}

.autocomplete-items::-webkit-scrollbar {
width: 10px;
}

/* Track */
::-webkit-scrollbar-track {
background: #f1f1f1; 
}

/* Handle */
::-webkit-scrollbar-thumb {
background: #888; 
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
background: #555; 
}

.autocomplete-items div {
	padding: 5px; /*10px*/
	cursor: pointer;
	background-color: #fff;
	/* border-bottom: 1px solid #d4d4d4; */
}

/*when hovering an item:*/
.autocomplete-items div:hover {
	background-color: #e9e9e9;
}

/*when navigating through the items using the arrow keys:*/
.autocomplete-active {
	background-color: DodgerBlue !important;
	color: #ffffff;
}
		
		
.autocomplete-error-msg {
    display: block;
    position: absolute;
    top: 100%;
    right: 0px;
    z-index: 10;
    width: 100%;
    color: #FF5959;
    font-size: 20px;
    background: rgba(228,228,228,.77);
    text-align: center;
    margin-top: 5px;
}


.autocomplete-error-msg.show{
  visibility: visible;
}

.autocomplete-error-msg.hide{
	visibility: hidden;
	transition: visibility 0s 2s, opaminhali 2s linear;
}

.autocomplete-badge {
    position: absolute;
    left: 2px;
		color:#00477e;
		font-weight: 400;
    background-color: #f1f1f1!important;
    border-radius: 50%;
    display: inline-block;
		text-align: center;
		padding-left: 8px;
		padding-right: 8px;

}






* {
    box-sizing: border-box;
}



input[type=text] {
    width: 100%;
}

input[type=submit] {
    background-color: DodgerBlue;
    color: #fff;
    cursor: pointer;
}

input {
    border: 1px solid transparent;
    background-color: #f1f1f1;
    padding: 10px;
    font-size: 12px;
}

#ac-result, #ac-details{
    width:100%;
}

.autocomplete, #subject-select, #ds-select{
    width:200px !important;
}
@media screen and (min-width: 800px) {
    #ac-result #ac-details{
        padding-right:310px;
    }

    .autocomplete, #subject-select, #ds-select{
        width:40% !important;
    }
}




.border {
  border: 2px dashed orange;
}






.v-application{
  font-family: "Rubik", sans-serif;
}
.div{
  font-family: "Rubik", sans-serif;
}



::v-deep .my-checkbox .v-label {
 font-size: 12px;
}

.slide-in-right{-webkit-animation:slide-in-right .5s cubic-bezier(.25,.46,.45,.94) both;animation:slide-in-right .5s cubic-bezier(.25,.46,.45,.94) both}
@-webkit-keyframes slide-in-right{0%{-webkit-transform:translateX(1000px);transform:translateX(1000px);opaminhali:0}100%{-webkit-transform:translateX(0);transform:translateX(0);opaminhali:1}}@keyframes slide-in-right{0%{-webkit-transform:translateX(1000px);transform:translateX(1000px);opaminhali:0}100%{-webkit-transform:translateX(0);transform:translateX(0);opaminhali:1}}


</style>
